import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import './style.css'
import Spacer from '../Spacer'
import Divider from '../Divider'
import { THEMES } from 'src/constatnts'
import { Button } from 'src/pages/specialoffer'

export const NavButton = ({
  fullwidth = false,
  children,
  to = '#',
  variant = 'light',
  size = 'sm',
  style = {},
  onClick = null,
  self = false,
  ref = null
}) => {
  return (
    <button
      ref={ref}
      className={'row row-center '}
      style={{
        border: variant == 'light' ? '1px solid #0075BC' : 0,
        background: variant == 'light' ? '#FFFFFF' : '#0075BC',
        padding: size == 'sm' || size == 'xs' ? '8px 35px' : '22px 35px',
        cursor: 'pointer',
        ...(fullwidth && { width: '100%', justifyContent: 'center' }),
        ...style
      }}
      onClick={() => {
        onClick ? onClick() : window.open(to, self ? '_self' : '_blank').focus()
      }}
    >
      <span
        style={{
          fontFamily: 'Source Sans 3',
          textTransform: 'uppercase',
          letterSpacing: size == 'sm' || size == 'xs' ? 1 : 1.6,
          color: variant == 'light' ? '#0075BC' : '#fff',
          fontSize: size == 'sm' ? 12 : size == 'xs' ? 8 : 16
        }}
      >
        {children}
      </span>
    </button>
  )
}

export const NavigationASBO = ({ theme, style, loc = 'uk' }) => {
  const [mobileMenuShown, setMobileMenuShown] = useState(false)
  const [mobileFormShown, setMobileFormShown] = useState(false)

  const handleOpenMenu = () => {
    document.body.classList.toggle('lock-scroll')
    setMobileMenuShown(!mobileMenuShown)
  }

  const navigate = useNavigate()

  return (
    <div style={style} className={'nav row row-center asbo ' + theme}>
      <div className='container1300 row row-center'>
        <div className='row row-center' style={{ width: '100%' }}>
          <NavLink to='/'>
            <img src='/images/logo-asbo-nav.png' style={{ width: 300 }} alt='' />
          </NavLink>
          <Spacer />
          <div onClick={handleOpenMenu} className='burger-menu-button'>
            <svg width='19' height='16' viewBox='0 0 19 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M1 1H17.9987'
                stroke={theme == THEMES.light ? '#1D1D29' : '#444444'}
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M1 8.00049H17.9987'
                stroke={theme == THEMES.light ? '#1D1D29' : '#444444'}
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M1 15H17.9987'
                stroke={theme == THEMES.light ? '#1D1D29' : '#444444'}
                strokeWidth='2'
                strokeLinecap='round'
              />
            </svg>
          </div>

          {mobileMenuShown && (
            <div className='mobile-menu'>
              <div className='row row-center'>
                <img src='/images/logo-asbo-nav.png' width={255} alt='' />
                <Spacer />
                <div onClick={handleOpenMenu} className='burger-menu-button'>
                  <svg width='25' height='26' viewBox='0 0 25 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M6.24219 6.75391L18.7422 19.2539'
                      stroke='#444444'
                      strokeWidth='1.75'
                      strokeLinecap='round'
                    />
                    <path
                      d='M6.24219 19.2461L18.7422 6.7461'
                      stroke='#444444'
                      strokeWidth='1.75'
                      strokeLinecap='round'
                    />
                  </svg>
                </div>
              </div>

              <Divider style={{ margin: '0px 0px 50px 0px', background: '#D8D8FF' }} />
              <Button
                onClick={() => {
                  navigate('/asbo/book-a-demo')
                  document.body.classList.toggle('lock-scroll')
                }}
                className='mb60'
                variant='contained'
                fullWidth
                sx={{
                  paddingX: '60px'
                }}
              >
                Book a demo
                <svg
                  style={{ marginLeft: 30 }}
                  width='10'
                  height='14'
                  viewBox='0 0 10 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M5.92375 7.00014L0.743408 1.88021L2.3385 0.303711L9.11394 7.00014L2.3385 13.6966L0.743408 12.1201L5.92375 7.00014Z'
                    fill='white'
                  />
                </svg>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
